<template>
  <div id="app">
    <Tabbar /> 
  </div>
</template>

<script>
export default {
  name: "App",
  watch: {
    $route: {
      handler(to, from) {
        console.info(to)
        if (to.name == "ShowReport") {
          document.getElementById("viewport").setAttribute('content','user-scalable=yes, width=device-width, minimum-scale=1, initial-scale=1, maximum-scale=2')
        } else {
          document.getElementById("viewport").setAttribute('content','user-scalable=no, width=device-width, minimum-scale=1, initial-scale=1, maximum-scale=1')
        }
      },
    },
  },
  components: {
  }
};
</script>
<script>
function addMeta(name, content){//手动添加mate标签
    let meta = document.createElement('meta');
    meta.content=content;
    meta.name=name;
    document.getElementsByTagName('head')[0].appendChild(meta);
}
window.onload = function () {
  // addMeta('viewport', 'maximum-scale=1.0,minimum-scale=1.0,user-scalable=0,width=device-width,initial-scale=1.0')
  addMeta('format-detection', 'telephone=no')
  addMeta('applicable-device', 'mobile')
  addMeta('apple-mobile-web-app-capable', 'yes')
  document.addEventListener("touchstart", function (event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  });
  document.addEventListener("gesturestart", function (event) {
    event.preventDefault();
  });
};
// 字体问题
function gethtmlfontsize(){
    const oHtml = document.getElementsByTagName('html')[0]
    const width = oHtml.clientWidth;
    // 320px的屏幕基准像素为12px
    oHtml.style.fontSize = 12 * (width / 320) + "px";
}
// 调用一次
gethtmlfontsize();
// 添加监听事件(resize是监听的意思)
window.addEventListener('resize',gethtmlfontsize)
</script>
<style lang="less">
@import url('./assets/css/style.css');
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.wx {
  height: 60%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
